import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import { toast } from "react-toastify";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import diasService from "./diasService";

const initialState = {
  documents: [],
  documentscustomerinfo: [],
  showRegio: false,
  downloadPDF: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    doc: null,
    extension: null,
    filename: null,
    timestamp: null,
    initialPage: null,
  },
  customers: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    customers: null,
  },
  GetAutomaticFollowups: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    data: null,
  },
  CreateUpdateContact: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
  },
  GetMapData: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    data: null,
    message: null,
  },
  selectedCustomer: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    customer: null,
    customerstructure: null,
    artHistory: null,
  },
  // Customer explicitly chosen for shop prices (klantfiche "Selecteer deze klant").
  // Separate from selectedCustomer, which is only the klantfiche being viewed.
  shopCustomer: {
    customer: null,
    artHistory: null,
  },
  dataDrop: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
  },
  search: {
    contacts: {
      result: [],
      isError: false,
      isSuccess: false,
      isLoading: false,
      latestRequestId: 0,
    },
  },
  SyncDataSagetoDoc: {
    result: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  SyncLevTypetoDoc: {
    result: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  queryDocuments: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
  },
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  contactreport: {
    // voor het onthouden van formulier gegevens als men naar een andere pagina gaat
    formdata: {
      DossierID: 10,
      parentdocs: [], // Gerelateerde documenten
      RDNBZK: "", // Reden bezoek
      LCTBZK: "", // Locatie bezoek
      bzkfrqnt: "",
      DTBZTM: "", // Begin
      DTMVRTRK: "", // Einde
      PRDCTCTGR: [], // Product categorie
      MDVRTGNWRDGR: [{ label: "geen", value: "geen" }], // Medevertegenwoordiger
      BEZRESULT: [], // Contactresultaat
      BZKMRWRD: "", // Contactmeerwaarde
      TYPE_BEZ: "", // Type Bezoek
      LASPOTKL: "", // Laspotentieel klant
      LASPOTWELDA: "", // Laspotentieel Welda
      LASCONLEV: [], // Las concurrerend leverancier
      LASCONMERK: [], // Las concurrerend merk
      LASTPOTKL: "",
      LASTPOTWELDA: "",
      LASTCONLEV: [],
      LASTCONMERK: [],
      MACHPOTKL: "",
      MACHPOTWELDA: "",
      MACHCONLEV: [],
      MACHCONMERK: [],
      TOOLPOTKL: "",
      TOOLPOTWELDA: "",
      TOOLCONLEV: [],
      TOOLCONMERK: [],
    },
    RGLNKDSFNRP: "",
  },
  CreateDocument: {
    result: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  UpdateDocument: {
    result: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
  },
  offertefilters: [
    "CTGRN",
    "PRRT",
    "CTGRFFRT",
    "OFFSTAT",
    "SLGNGSPRCNTG",
    "SRTPRDCT",
  ],
  UDP: {
    CTGRN: {
      label: "Categorie Product",
      data: [
        { value: "WLDNG", label: "Lassen" },
        { value: "LSTFLS", label: "Lastafels" },
        { value: "MCHNS", label: "Machines" },
        { value: "GRDSCHP", label: "Gereedschappen" },
      ],
      multiselect: false,
    },
    PRRT: {
      label: "Prioriteit",
      data: [
        { value: "1", label: "Belangrijk & Dringend" },
        { value: "2", label: "Belangrijk & Niet Dringend" },
        { value: "3", label: "Dringend & Niet Belangrijk" },
        { value: "4", label: "Niet Dringend & Niet Belangrijk" },
      ],
      multiselect: false,
    },
    CTGRFFRT: {
      label: "Categorie Offerte",
      data: [
        { value: "10", label: "Manuele Opvolging" },
        { value: "20", label: "Full Automatic" },
        { value: "21", label: "Semi-Automatic" },
        { value: "90", label: "Manuele Na-opvolging" },
      ],
      multiselect: false,
    },
    OFFSTAT: {
      label: "Status Offerte",
      data: [
        { value: "G", label: "Geannuleerd" },
        { value: "L", label: "Lopend" },
        { value: "Vc", label: "VKO opmaken" },
        { value: "Vk", label: "Reeds verkocht" },
        { value: "Vl", label: "Verloren" },
      ],
      multiselect: false,
    },
    SLGNGSPRCNTG: {
      label: "Slagingspercentage",
      data: [
        { value: "10", label: "10%" },
        { value: "25", label: "25%" },
        { value: "50", label: "50%" },
        { value: "75", label: "75%" },
        { value: "90", label: "90%" },
      ],
      multiselect: false,
    },
    SRTPRDCT: {
      label: "Soort Verkoop",
      data: [
        { value: "111", label: "Invest LongTerm" },
        { value: "112", label: "Invest ShortTerm" },
        { value: "121", label: "Use & Repairable" },
        { value: "122", label: "Use & Keep Slow Away" },
        { value: "123", label: "Use & Throw away fast" },
        { value: "125", label: "Accessoires & Toebehoren" },
        { value: "400", label: "Service & Parts" },
        { value: "500", label: "Rental" },
        { value: "900", label: "Other" },
        { value: "990", label: "Onbepaald" },
        { value: "999", label: "No Idea - Help me" },
      ],
      multiselect: false,
    },
    PRDCTCTGR: {
      data: [
        { value: "LASSEN", label: "Lassen" },
        { value: "LASTAFEL", label: "Lastafels" },
        { value: "MACHINE", label: "Machines" },
        { value: "TOOL", label: "Gereedschappen" },
      ],
      multiselect: true,
    },
    MDVRTGNWRDGR: {
      data: [
        { value: "Antonis Dirk", label: "Antonis Dirk" },
        { value: "De Bock Jonas", label: "De Bock Jonas" },
        { value: "De Bruyne Koen", label: "De Bruyne Koen" },
        { value: "Dekeukelaere Stefan", label: "Dekeukelaere Stefan" },
        { value: "Verheye Patrick", label: "Verheye Patrick" },
        { value: "Naert Bert", label: "Naert Bert" },
        // {value: 'Technieker', label:'Technieker'}, //bestaat nog niet in Dias
        { value: "INTERIM", label: "INTERIM" },
      ],
      multiselect: true,
    },
    BEZRESULT: {
      data: [
        { value: "PROSPECT1", label: "Eerste kennismaaking / prospect" },
        { value: "PRIJSAANV1", label: "Prijsaanvraag gekregen" },
        { value: "OFFVERD1", label: "Offerte / project bespreking" },
        { value: "BEST1", label: "Bestelling genoteerd" },
        { value: "DEMO1", label: "Demo of technish advies gegeven" },
        { value: "OPSTSUCCES1", label: "Opstart of opleiding" },
        { value: "NWPROD1", label: "Nieuw product voorgesteld" },
        { value: "KLACHT1", label: "Klacht ontvangen / behandeld" },
        { value: "KLOPL1", label: "Klant info / oplossing geboden" },
        { value: "INFO1", label: "Folders afgeven" },
        {
          value: "ZONGEV1",
          label: "Informeel bezoek / niets bijz. / zonder gevolg",
        },
        { value: "NTAANW1", label: "Niet aanwezig / afspraak gemist" },
        { value: "MATGEL1", label: "Materiaal geleverd" },
      ],
      multiselect: true,
    },
    BZKMRWRD: {
      data: [
        { value: "NEGATIEF", label: "Negatief" },
        { value: "NEUTRAAL", label: "Neutraal" },
        { value: "POSITIEF", label: "Positief" },
        { value: "EXTRGOED", label: "Extreem goed" },
      ],
      multiselect: false,
    },
    TYPE_BEZ: {
      data: [
        { value: "tb_Afspr", label: "Op afspraak" },
        { value: "tb_pass", label: "Zonder afspraak" },
      ],
      multiselect: false,
    },
    LCTBZK: {
      data: [
        { value: "TEL", label: "Telefoongesprek" },
        { value: "KLANT", label: "Bezoek bij de klant" },
        { value: "LEV", label: "Bezoek bij leverancier" },
        { value: "WELDA", label: "Bezoek bij Welda" },
        { value: "OVERIG", label: "Overige" },
      ],
      multiselect: false,
    },
    LASCONLEV: {
      data: [
        { value: "CBL", label: "CBL" },
        { value: "Partool", label: "Partool" },
        { value: "Debaenst", label: "Debaenst Lastechniek" },
        { value: "lastek", label: "Lastek Belgium" },
        { value: "DWK", label: "DWK Welding Solutions" },
        { value: "Vandewalle", label: "V.D.W. Lastechniek" },
        { value: "metalas", label: "Metalas" },
        { value: "Detollenaere", label: "De Tollenaere" },
        { value: "ufttools", label: "Ufttools - Uftlas" },
        { value: "DeBacker", label: "De Backer Welding" },
        { value: "Lasservice", label: "Las Service" },
        { value: "Dekinder", label: "De Kinder Hardware" },
        { value: "Technolit", label: "Technolit" },
      ],
      multiselect: true,
    },
    LASCONMERK: {
      data: [
        { value: "airliquide", label: "Airliquide" },
        { value: "Migatronic", label: "Migatronic" },
        { value: "Lincoln", label: "Lincoln" },
        { value: "KEMPPI", label: "Kemppi" },
        { value: "Lastek", label: "Lastek" },
        { value: "parweld", label: "Parweld" },
        { value: "Cerdi", label: "Cerdi" },
        { value: "Lorch", label: "Lorch" },
        { value: "Cebora", label: "Cebora" },
        { value: "fronius", label: "Fronius" },
        { value: "Esab", label: "Esab" },
        { value: "ROWAC", label: "Rowac" },
        { value: "Fanuci", label: "Fanuci" },
        { value: "Technolit", label: "Technolit" },
      ],
      multiselect: true,
    },
    LASTCONLEV: {
      data: [
        { value: "CBL", label: "CBL" },
        { value: "partool", label: "Partool NV" },
        { value: "Debaenst", label: "Debaenst Lastechniek BVBA" },
        { value: "lastek", label: "Lastek Belgium NV" },
        { value: "DWK", label: "DWK Welding Solutions" },
        { value: "Vandewalle", label: "V.D.W. Lastechniek bvba" },
        { value: "metalas", label: "Metalas nv" },
      ],
      multiselect: true,
    },
    LASTCONMERK: {
      data: [
        { value: "Bessey", label: "Bessey" },
        { value: "Demmeler", label: "Demmeler" },
      ],
      multiselect: true,
    },
    MACHCONLEV: {
      data: [
        { value: "crispyn", label: "Crispyn" },
        { value: "Vandewalle", label: "V.D.W. Lastechniek bvba" },
        { value: "Haco", label: "Haco" },
        { value: "Detollenaere", label: "De Tollenaere" },
        { value: "HBM", label: "HBM Machines" },
        { value: "deratech", label: "Deratech" },
        { value: "Haas", label: "Haas Automation" },
        { value: "LVD", label: "LVD" },
        { value: "Voortman", label: "Voortman" },
        { value: "Metanox", label: "Metanox" },
        { value: "Bystronic", label: "Bystronic" },
        { value: "Trumph", label: "Trumph" },
      ],
      multiselect: true,
    },
    MACHCONMERK: {
      data: [
        { value: "Optimum", label: "Optimum" },
        { value: "Contimac", label: "Contimac" },
        { value: "Swiftcut", label: "Swiftcut" },
        { value: "Haco", label: "Haco" },
        { value: "Meba", label: "Meba" },
        { value: "FMB", label: "FMB" },
        { value: "deratech", label: "Deratech" },
        { value: "Haas", label: "Haas Automation" },
        { value: "HBM", label: "HBM Machines" },
        { value: "Trumph", label: "Trumph" },
        { value: "LVD", label: "LVD" },
        { value: "lincoln", label: "Lincoln" },
        { value: "Voortman", label: "Voortman" },
        { value: "Bystronic", label: "Bystronic" },
        { value: "MGM", label: "MGM" },
        { value: "Ercolina", label: "Ercolina" },
        { value: "Kaltenbach", label: "Kaltenbach" },
        { value: "Kemper", label: "Kemper" },
        { value: "MVD", label: "MVD" },
        { value: "Serrmac", label: "Serrmac" },
        { value: "Huvema", label: "Huvema" },
      ],
      multiselect: true,
    },
    TOOLCONLEV: {
      data: [
        { value: "Claerbout", label: "Metaalwaren Claerbout" },
        { value: "Vancanneyt", label: "Vancanneyt" },
        { value: "Lecot", label: "Lecot" },
        { value: "Detollenaere", label: "De Tollenaere" },
        { value: "HBM", label: "HBM Machines" },
        { value: "Hoffman", label: "Hoffman Group" },
        { value: "Elis", label: "Eldis" },
        { value: "Imes", label: "Imes Dexis" },
        { value: "Dekinder", label: "De Kinder Hardware" },
        { value: "Technolit", label: "Technolit" },
        { value: "ufttools", label: "Ufttools - Uftlas" },
        { value: "partool", label: "Partool" },
        { value: "Hilti", label: "Hilti" },
        { value: "vandevelde", label: "Van De Velde - Willems" },
      ],
      multiselect: true,
    },
    TOOLCONMERK: {
      data: [
        { value: "Bosch", label: "Bosch" },
        { value: "Makita", label: "Makita" },
        { value: "Milwaukee", label: "Milwaukee" },
        { value: "Hilti", label: "Hilti" },
        { value: "Metabo", label: "Metabo" },
        { value: "Hikoki", label: "Hitachi - HiKOKI" },
        { value: "Ridgid", label: "Ridgid" },
        { value: "3M", label: "3M" },
        { value: "Festool", label: "Festool" },
        { value: "Dewalt", label: "DeWALT" },
        { value: "Ferm", label: "Ferm" },
        { value: "Black&decker", label: "Black & Decker" },
        { value: "Altrex", label: "Altrex" },
        { value: "Knipex", label: "Knipex" },
        { value: "Lenox", label: "Lenox" },
        { value: "Facom", label: "Facom" },
        { value: "Stahlwille", label: "Stahlwille" },
        { value: "Force", label: "Force" },
      ],
      multiselect: true,
    },
  },
};

export const GetAutomaticFollowups = createAsyncThunk(
  "dias/GetAutomaticFollowups",
  async (diasData, thunkAPI) => {
    // let ToastLoading = toast.loading("Contact(en) create/update...", {closeOnClick: true})
    try {
      const awaitGetAutomaticFollowups =
        await diasService.GetAutomaticFollowups(diasData);
      // setTimeout(function(){toast.dismiss(ToastLoading)}, 2000)
      return awaitGetAutomaticFollowups;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const CreateUpdateContact = createAsyncThunk(
  "dias/CreateUpdateContact",
  async (diasData, thunkAPI) => {
    let ToastLoading = toast.loading("Contact(en) create/update...", {
      closeOnClick: true,
    });
    try {
      const awaitGetCustomers = await diasService.CreateUpdateContactAsync(
        diasData
      );
      setTimeout(function () {
        toast.dismiss(ToastLoading);
      }, 2000);
      return awaitGetCustomers;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCustomerByERPklaNr = createAsyncThunk(
  "dias/getCustomerByERPklaNr",
  async (klantnr, thunkAPI) => {
    try {
      return await diasService.getCustomerByERPklaNr(klantnr);
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SyncDataSagetoDoc = createAsyncThunk(
  "dias/SyncDataSagetoDoc",
  async (diasData, thunkAPI) => {
    let ToastLoading = toast.loading("Data synchroniseren...", {
      closeOnClick: true,
    });
    try {
      const awaitSyncDataSagetoDoc = await diasService.SyncDataSagetoDoc(
        diasData
      );
      setTimeout(function () {
        toast.dismiss(ToastLoading);
      }, 2000);
      return awaitSyncDataSagetoDoc;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SyncLevTypetoDoc = createAsyncThunk(
  "dias/SyncLevTypetoDoc",
  async (diasData, thunkAPI) => {
    let ToastLoading = toast.loading("Data synchroniseren...", {
      closeOnClick: true,
    });
    try {
      const awaitSyncLevTypetoDoc = await diasService.SyncLevTypetoDoc(
        diasData
      );
      setTimeout(function () {
        toast.dismiss(ToastLoading);
      }, 2000);
      return awaitSyncLevTypetoDoc;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

let ToastLoadingGetCustomers = null;
export const GetCustomers = createAsyncThunk(
  "dias/GetCustomers",
  async (diasData, thunkAPI) => {
    // ToastLoadingGetCustomers && toast.dismiss(ToastLoadingGetCustomers);
    // ToastLoadingGetCustomers = toast.loading("Contact(en) ophalen...", {
    //   closeOnClick: true,
    //   autoClose: 20000,
    // });
    try {
      const awaitGetCustomers = await diasService.GetCustomers(diasData);
      // setTimeout(function () {
      //   toast.dismiss(ToastLoadingGetCustomers);
      // }, 2000);
      return awaitGetCustomers;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

let ToastLoadingGetCustomerStructure = null;
export const GetCustomerStructure = createAsyncThunk(
  "dias/GetCustomerStructure",
  async (diasData, thunkAPI) => {
    try {
      const awaitGetCustomerStructure = await diasService.GetCustomerStructure(
        diasData
      );
      return awaitGetCustomerStructure;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const QueryDocuments = createAsyncThunk(
  "dias/QueryDocuments",
  async (diasData, thunkAPI) => {
    // let ToastLoading = toast.loading("Document(en) ophalen...", {
    //   closeOnClick: true,
    // });
    try {
      const awaitQueryDocuments = await diasService.QueryDocuments(diasData);
      // setTimeout(function () {
      //   toast.dismiss(ToastLoading);
      // }, 2000);
      return awaitQueryDocuments;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const SearchContacts = createAsyncThunk(
  "dias/SearchContacts",
  async (diasData, thunkAPI) => {
    try {
      return await diasService.SearchContacts(diasData.searchData);
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const dataDrop = createAsyncThunk(
  "dias/datadrop",
  async (diasData, thunkAPI) => {
    try {
      return await diasService.dataDrop(diasData);
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const GetMapData = createAsyncThunk(
  "dias/GetMapData",
  async (params, thunkAPI) => {
    try {
      const awaitGetMapData = await diasService.GetMapData(params);
      return awaitGetMapData;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const UpdateDocument = createAsyncThunk(
  "dias/UpdateDocument",
  async (diasData, thunkAPI) => {
    let ToastLoading = toast.loading("Document updaten...", {
      closeOnClick: true,
    });
    try {
      const awaitUpdateDocument = await diasService.UpdateDocument(diasData);
      toast.update(ToastLoading, {
        render: "Aanpassing gedaan!",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        theme: "colored",
        closeOnClick: true,
      });
      return awaitUpdateDocument;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const CreateDocument = createAsyncThunk(
  "dias/CreateDocument",
  async (diasData, thunkAPI) => {
    try {
      let ToastLoading = toast.loading("Document aanmaken...", {
        closeOnClick: true,
      });

      const awaitcreatedoc = await diasService.CreateDocument(diasData);

      toast.update(ToastLoading, {
        render: `Document aangemaakt`,
        type: "success",
        isLoading: false,
        autoClose: 5000,
        theme: "colored",
        closeOnClick: true,
      });
      return awaitcreatedoc;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DownloadDocument = createAsyncThunk(
  "dias/DownloadDocument",
  async (diasData, thunkAPI) => {
    try {
      let ToastLoading = toast.loading("Document ophalen...", {
        closeOnClick: true,
      });

      const awaitDownloadDocument = await diasService.DownloadDocument(
        diasData
      );
      setTimeout(function () {
        toast.dismiss(ToastLoading);
      }, 2000);
      return awaitDownloadDocument;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DownloadPublicDocument = createAsyncThunk(
  "dias/DownloadPublicDocument",
  async (diasData, thunkAPI) => {
    try {
      let ToastLoading = toast.loading("Document ophalen...", {
        closeOnClick: true,
      });
      const awaitDownloadDocument =
        await diasService.DownloadPublicDocumentExtra(diasData);
      setTimeout(function () {
        toast.dismiss(ToastLoading);
      }, 2000);
      return awaitDownloadDocument;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Custom equality checking function

export const diasSlice = createSlice({
  name: "dias",
  initialState,
  reducers: {
    reset: (state) => {
      return initialState;
    },
    reset_downloadPDF: (state) => {
      state.downloadPDF = initialState.downloadPDF;
    },
    resetSelectedCustomer: (state) => {
      state.selectedCustomer = initialState.selectedCustomer;
    },
    resetSearch: (state) => {
      state.search = initialState.search;
    },
    setDocumentscustomerinfo: (state, action) => {
      state.documentscustomerinfo = action.payload;
    },
    setShowRegio: (state, action) => {
      state.showRegio = action.payload;
    },
    setContactreport: (state, action) => {
      state.contactreport = {
        ...state.contactreport,
        ...action.payload,
        formdata: {
          ...state.contactreport.formdata,
          ...action.payload.formdata,
        },
      };
    },
    resetContactreport: (state, action) => {
      state.contactreport = initialState.contactreport;
    },
    contactReportAddParent: (state, action) => {
      // Check if the item already exists in the array before adding it
      const newItem = action.payload;
      if (
        !state.contactreport.formdata.parentdocs.some((item) =>
          isEqual(item, newItem)
        )
      ) {
        state.contactreport.formdata.parentdocs = [
          ...state.contactreport.formdata.parentdocs,
          newItem,
        ];
      }
    },
    contactReportRemoveParent: (state, action) => {
      const itemToRemove = action.payload;
      const updatedItems = state.contactreport.formdata.parentdocs.filter(
        (item) => !isEqual(item, itemToRemove)
      );
      state.contactreport.formdata.parentdocs = updatedItems;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = {
        ...state.selectedCustomer,
        ...action.payload,
      };
      const viewedContactObj = state.selectedCustomer.customer?.Contact_obj;
      if (
        action.payload?.artHistory !== undefined &&
        viewedContactObj != null &&
        state.shopCustomer.customer?.Contact_obj === viewedContactObj
      ) {
        state.shopCustomer.artHistory = action.payload.artHistory;
      }
    },
    /** payload: { customer, artHistory? } */
    selectShopCustomer: (state, action) => {
      state.shopCustomer = {
        customer: action.payload?.customer ?? null,
        artHistory: action.payload?.artHistory ?? null,
      };
    },
    resetShopCustomer: (state) => {
      state.shopCustomer = initialState.shopCustomer;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SyncDataSagetoDoc.pending, (state) => {
        state.SyncDataSagetoDoc.isLoading = true;
        state.SyncDataSagetoDoc.isSuccess = false;
        state.SyncDataSagetoDoc.message = null;
      })
      .addCase(SyncDataSagetoDoc.fulfilled, (state, action) => {
        state.SyncDataSagetoDoc.isLoading = false;
        state.SyncDataSagetoDoc.isSuccess = true;
        state.SyncDataSagetoDoc.message = null;
        state.SyncDataSagetoDoc.result = action.payload;
      })
      .addCase(SyncDataSagetoDoc.rejected, (state, action) => {
        state.SyncDataSagetoDoc.isLoading = false;
        state.SyncDataSagetoDoc.isError = true;
        state.SyncDataSagetoDoc.message = action.payload;
      })
      .addCase(SyncLevTypetoDoc.pending, (state) => {
        state.SyncLevTypetoDoc.isLoading = true;
        state.SyncLevTypetoDoc.isSuccess = false;
        state.SyncLevTypetoDoc.message = null;
      })
      .addCase(SyncLevTypetoDoc.fulfilled, (state, action) => {
        state.SyncLevTypetoDoc.isLoading = false;
        state.SyncLevTypetoDoc.isSuccess = true;
        state.SyncLevTypetoDoc.message = null;
        state.SyncLevTypetoDoc.result = action.payload;
      })
      .addCase(SyncLevTypetoDoc.rejected, (state, action) => {
        state.SyncLevTypetoDoc.isLoading = false;
        state.SyncLevTypetoDoc.isError = true;
        state.SyncLevTypetoDoc.message = action.payload;
      })
      .addCase(GetCustomerStructure.pending, (state) => {
        state.selectedCustomer.isLoading = true;
        state.selectedCustomer.message = null;
        state.selectedCustomer.artHistory = null;
      })
      .addCase(GetCustomerStructure.fulfilled, (state, action) => {
        state.selectedCustomer.isLoading = false;
        state.selectedCustomer.isSuccess = true;
        state.selectedCustomer.message = null;
        state.selectedCustomer.customer = action.payload;
      })
      .addCase(GetCustomerStructure.rejected, (state, action) => {
        state.selectedCustomer.isLoading = false;
        state.selectedCustomer.isError = true;
        state.selectedCustomer.message = action.payload;
      })
      .addCase(GetCustomers.pending, (state) => {
        state.customers.isLoading = true;
        state.customers.message = null;
        state.customers.customers = null;
      })
      .addCase(GetCustomers.fulfilled, (state, action) => {
        state.customers.isLoading = false;
        state.customers.isSuccess = true;
        state.customers.message = null;
        state.customers.customers = action.payload.customers;
      })
      .addCase(GetCustomers.rejected, (state, action) => {
        state.customers.isLoading = false;
        state.customers.isError = true;
        state.customers.message = action.payload;
      })
      .addCase(CreateUpdateContact.pending, (state) => {
        state.CreateUpdateContact.isLoading = true;
        state.CreateUpdateContact.isSuccess = false;
        state.CreateUpdateContact.message = null;
      })
      .addCase(CreateUpdateContact.fulfilled, (state, action) => {
        state.CreateUpdateContact.isLoading = false;
        state.CreateUpdateContact.isSuccess = true;
        state.CreateUpdateContact.message = null;
        const customer = action.payload;
        if (customer) {
          if (
            state.selectedCustomer.customer &&
            state.selectedCustomer.customer.Contact_obj === customer.Contact_obj
          ) {
            state.selectedCustomer.customer = customer;
          }
          if (
            state.shopCustomer.customer &&
            state.shopCustomer.customer.Contact_obj === customer.Contact_obj
          ) {
            state.shopCustomer.customer = customer;
          }
          state.documentscustomerinfo = state.documentscustomerinfo.map(
            (doc) => {
              if (doc.customer?.Contact_obj === customer.Contact_obj) {
                return { ...doc, customer };
              } else {
                return doc;
              }
            }
          );
        }
      })
      .addCase(CreateUpdateContact.rejected, (state, action) => {
        state.CreateUpdateContact.isLoading = false;
        state.CreateUpdateContact.isSuccess = false;
        state.CreateUpdateContact.isError = true;
      })
      .addCase(DownloadDocument.pending, (state) => {
        state.downloadPDF.isLoading = true;
        state.downloadPDF.message = null;
      })
      .addCase(DownloadDocument.fulfilled, (state, action) => {
        state.downloadPDF.isLoading = false;
        state.downloadPDF.isSuccess = true;
        state.downloadPDF.message = null;
        state.downloadPDF.doc = action.payload.base64.file;
        state.downloadPDF.filename = action.payload.filename;
        state.downloadPDF.extension = action.payload.base64.extension;
        state.downloadPDF.timestamp = Date.now();
        state.downloadPDF.initialPage =
          typeof action.meta?.arg?.initialPage === "number"
            ? action.meta.arg.initialPage
            : null;
      })
      .addCase(DownloadDocument.rejected, (state, action) => {
        state.downloadPDF.isLoading = false;
        state.downloadPDF.isError = true;
        state.downloadPDF.message = action.payload;
      })
      .addCase(DownloadPublicDocument.pending, (state) => {
        state.downloadPDF.isLoading = true;
        state.downloadPDF.message = null;
      })
      .addCase(DownloadPublicDocument.fulfilled, (state, action) => {
        state.downloadPDF.isLoading = false;
        state.downloadPDF.isSuccess = true;
        state.downloadPDF.message = null;
        state.downloadPDF.doc = action.payload.base64.file;
        state.downloadPDF.filename = action.payload.filename;
        state.downloadPDF.extension = action.payload.base64.extension;
        state.downloadPDF.timestamp = Date.now();
        state.downloadPDF.initialPage =
          typeof action.meta?.arg?.initialPage === "number"
            ? action.meta.arg.initialPage
            : null;
      })
      .addCase(DownloadPublicDocument.rejected, (state, action) => {
        state.downloadPDF.isLoading = false;
        state.downloadPDF.isError = true;
        state.downloadPDF.message = action.payload;
      })
      .addCase(QueryDocuments.pending, (state) => {
        state.queryDocuments.isLoading = true;
        state.queryDocuments.isError = false;
      })
      .addCase(QueryDocuments.fulfilled, (state, action) => {
        state.queryDocuments.isLoading = false;
        state.queryDocuments.isSuccess = true;
        state.isSuccess = true;
        state.documents = action.payload.documents;
        state.documentscustomerinfo = [];
      })
      .addCase(QueryDocuments.rejected, (state, action) => {
        state.queryDocuments.isLoading = false;
        state.queryDocuments.isError = true;
        state.queryDocuments.message = action.payload;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(SearchContacts.pending, (state, action) => {
        state.search.contacts.isLoading = true;
        const requestId = action.meta.arg?.options?.requestId;
        if (requestId != null) {
          state.search.contacts.latestRequestId = requestId;
        }
      })
      .addCase(SearchContacts.fulfilled, (state, action) => {
        const requestId = action.meta.arg?.options?.requestId;
        // Ignore outdated responses so intermediate queries can't overwrite better matches
        if (
          requestId != null &&
          requestId !== state.search.contacts.latestRequestId
        ) {
          return;
        }
        state.search.contacts.isLoading = false;
        state.search.contacts.isSuccess = true;
        if (action.meta.arg.options.addData) {
          if (action.payload) {
            const result = action.payload
              ?.map((searchresult) => {
                if (
                  !state.search.contacts.result.find(
                    (existing) =>
                      existing.Contact_obj === searchresult.Contact_obj
                  )
                ) {
                  return searchresult;
                }
              })
              .filter(function (x) {
                return x !== undefined;
              });
            if (result) {
              state.search.contacts.result =
                state.search.contacts.result.concat(result);
            }
          }
        } else {
          state.search.contacts.result = action.payload;
        }
      })
      .addCase(SearchContacts.rejected, (state, action) => {
        const requestId = action.meta.arg?.options?.requestId;
        if (
          requestId != null &&
          requestId !== state.search.contacts.latestRequestId
        ) {
          return;
        }
        state.search.contacts.isLoading = false;
        state.search.contacts.isError = true;
        state.search.contacts.result = [];
      })
      .addCase(UpdateDocument.pending, (state) => {
        state.UpdateDocument.isSuccess = false;
        state.UpdateDocument.isLoading = true;
        state.UpdateDocument.result = null;
      })
      .addCase(UpdateDocument.fulfilled, (state, action) => {
        // const DocumentIndex = state.documents.findIndex(
        //   (doc) => doc.Identification === parseInt(action.payload.Identification)
        // )
        // if (DocumentIndex !== -1) state.documents[DocumentIndex] = {...action.payload, Identification: parseInt(action.payload.Identification)}

        state.documentscustomerinfo = state.documentscustomerinfo.map((doc) => {
          if (doc.Identification === parseInt(action.payload.Identification)) {
            return {
              ...doc,
              ...action.payload,
              Identification: parseInt(action.payload.Identification),
            };
          } else {
            return doc;
          }
        });

        state.UpdateDocument.isLoading = false;
        state.UpdateDocument.isSuccess = true;
        state.UpdateDocument.result = action.payload;
      })
      .addCase(UpdateDocument.rejected, (state, action) => {
        state.UpdateDocument.isLoading = false;
        state.UpdateDocument.isError = true;
        state.UpdateDocument.message = action.payload;
      })
      .addCase(dataDrop.pending, (state) => {
        state.dataDrop.isSuccess = false;
        state.dataDrop.isLoading = true;
        state.dataDrop.result = null;
      })
      .addCase(dataDrop.fulfilled, (state, action) => {
        state.dataDrop.isLoading = false;
        state.dataDrop.isSuccess = true;
      })
      .addCase(dataDrop.rejected, (state, action) => {
        state.dataDrop.isLoading = false;
        state.dataDrop.isError = true;
        state.dataDrop.message = action.payload;
      })
      .addCase(GetAutomaticFollowups.pending, (state) => {
        state.GetAutomaticFollowups.isSuccess = false;
        state.GetAutomaticFollowups.isLoading = true;
        // Keep previous data while refreshing so Auto badges don't flicker/clear
      })
      .addCase(GetAutomaticFollowups.fulfilled, (state, action) => {
        state.GetAutomaticFollowups.isLoading = false;
        state.GetAutomaticFollowups.isSuccess = true;
        state.GetAutomaticFollowups.data = action.payload;
      })
      .addCase(GetAutomaticFollowups.rejected, (state, action) => {
        state.GetAutomaticFollowups.isLoading = false;
        state.GetAutomaticFollowups.isError = true;
      })
      .addCase(GetMapData.pending, (state) => {
        state.GetMapData.isSuccess = false;
        state.GetMapData.isLoading = true;
        state.GetMapData.isError = false;
        // Keep previous data so the matrix/map stay visible during refetch
      })
      .addCase(GetMapData.fulfilled, (state, action) => {
        state.GetMapData.isLoading = false;
        state.GetMapData.isSuccess = true;
        state.GetMapData.data = action.payload;
      })
      .addCase(GetMapData.rejected, (state, action) => {
        state.GetMapData.isLoading = false;
        state.GetMapData.isError = true;
        state.GetMapData.message = action.payload;
      })
      .addCase(CreateDocument.pending, (state) => {
        state.CreateDocument.isSuccess = false;
        state.CreateDocument.isLoading = true;
      })
      .addCase(CreateDocument.fulfilled, (state, action) => {
        state.CreateDocument.result = action.payload;
        state.CreateDocument.isLoading = false;
        state.CreateDocument.isSuccess = true;
        state.contactreport.formdata = {
          ...initialState.contactreport.formdata,
        };
        // Assuming action.payload is an array of objects
        action.payload.forEach((payloadItem) => {
          const DocumentIndex = state.documents.findIndex(
            (doc) => doc.Identification === parseInt(payloadItem.Identification)
          );

          if (DocumentIndex !== -1) {
            // Update the document in the state if found
            state.documents[DocumentIndex] = {
              ...payloadItem,
              Identification: parseInt(payloadItem.Identification),
            };
          } else {
            // Add the document to the state if not found
            state.documents.push({
              ...payloadItem,
              Identification: parseInt(payloadItem.Identification),
            });
          }
        });
      })
      .addCase(CreateDocument.rejected, (state, action) => {
        state.CreateDocument.isLoading = false;
        state.CreateDocument.isError = true;
        state.message = action.payload;
      });
  },
});

export const {
  reset,
  resetSearch,
  setSelectedCustomer,
  resetSelectedCustomer,
  selectShopCustomer,
  resetShopCustomer,
  reset_downloadPDF,
  setDocumentscustomerinfo,
  setShowRegio,
  setContactreport,
  contactReportRemoveParent,
  contactReportAddParent,
  resetContactreport,
} = diasSlice.actions;
export default diasSlice.reducer;
